import {
  Language,
  RandomReaderInstructionTypes,
} from '../../../enums/const-enums';

export interface RassRandomReaderTranslations {
  errors: {
    timeout: AppModel.TimeoutTranslation;
    continue: string;
  };
  numberMap: {
    [number: string]: string;
  };
  instructions: {
    instructionSegments: {
      initial: string;
      card: {
        leftSide: {
          creditCard: string;
          debitCard: string;
        };
        rightSide: string;
      };
      pressButton: {
        login: string;
        sign: string;
      };
      enterPIN: string;
      enterChecksum: {
        leftSide: Record<RandomReaderInstructionTypes, string>;
        rightSide: Record<RandomReaderInstructionTypes, string>;
      };
      okAgain: string;
      enterCode: {
        login: string;
        sign: string;
      };
    };
  };
}

const nlTranslations: RassRandomReaderTranslations = {
  errors: {
    timeout: {
      text: 'Fout bij het bereiken van de server, probeer opnieuw!',
      type: 'warning',
    },
    continue: 'Doorgaan',
  },
  numberMap: {
    '0': 'nul',
    '1': '&eacute;&eacute;n',
    '2': 'twee',
    '3': 'drie',
    '4': 'vier',
    '5': 'vijf',
    '6': 'zes',
    '7': 'zeven',
    '8': 'acht',
    '9': 'negen',
  },
  instructions: {
    instructionSegments: {
      initial:
        '<ul class="rds-unordered-list"><li>Voer eerst je rekeningnummer en pasnummer in.</li></ul>',
      card: {
        leftSide: {
          creditCard: 'Plaats de creditcard ',
          debitCard: 'Plaats betaalpas ',
        },
        rightSide: ' in de Random Reader Comfort.',
      },
      pressButton: {
        login: 'Druk op <strong>I</strong> (inloggen).',
        sign: 'Druk op <strong>S</strong> (signeren).',
      },
      enterPIN:
        'Toets de <strong>pincode</strong> in en druk op <strong>OK</strong>.',
      enterChecksum: {
        leftSide: {
          [RandomReaderInstructionTypes.RANDOM]: 'Toets het controlegetal',
          [RandomReaderInstructionTypes.AMOUNT]:
            'Toets het totaalbedrag van uw opdracht in, alleen de cijfers voor de komma. Dit is',
          [RandomReaderInstructionTypes.ACCOUNT]: 'Toets',
          [RandomReaderInstructionTypes.NUMBER]: 'Toets het controlegetal',
          [RandomReaderInstructionTypes.COUNT]: 'Toets het controlegetal',
        },
        rightSide: {
          [RandomReaderInstructionTypes.RANDOM]:
            ' <br> in en druk op <strong>OK</strong>.',
          [RandomReaderInstructionTypes.AMOUNT]:
            '. Druk dan op <strong>OK</strong>.',
          [RandomReaderInstructionTypes.ACCOUNT]:
            ' in. Dit is één van de door jou gebruikte rekeningnummers. Druk dan op <strong>OK</strong>.',
          [RandomReaderInstructionTypes.NUMBER]:
            ' <br> in en druk op <strong>OK</strong>.',
          [RandomReaderInstructionTypes.COUNT]:
            ' <br> in en druk op <strong>OK</strong>.',
        },
      },
      okAgain: 'Druk nogmaals op <strong>OK</strong>.',
      enterCode: {
        login:
          'Vul hieronder de toegangscode in die op de Random Reader Comfort getoond wordt.',
        sign: 'Vul hieronder de signeercode in die op je Random Reader Comfort getoond wordt.',
      },
    },
  },
};

const enTranslations: RassRandomReaderTranslations = {
  errors: {
    timeout: {
      text: 'Error while reaching the server, please try again!',
      type: 'warning',
    },
    continue: 'Continue',
  },
  numberMap: {
    '0': 'zero',
    '1': 'one',
    '2': 'two',
    '3': 'three',
    '4': 'four',
    '5': 'five',
    '6': 'six',
    '7': 'seven',
    '8': 'eight',
    '9': 'nine',
  },
  instructions: {
    instructionSegments: {
      initial:
        '<ul class="rds-unordered-list"><li>Please enter your account number and card number.</li></ul>',
      card: {
        leftSide: {
          creditCard: 'Insert credit card ',
          debitCard: 'Insert bank card ',
        },
        rightSide: ' into the Random Reader Comfort.',
      },
      pressButton: {
        login: 'Press <strong>I</strong> (login).',
        sign: 'Press <strong>S</strong> (sign).',
      },
      enterPIN: 'Enter your PIN and press <strong>OK</strong>.',
      enterChecksum: {
        leftSide: {
          [RandomReaderInstructionTypes.RANDOM]: 'Enter checksum',
          [RandomReaderInstructionTypes.AMOUNT]:
            'Enter the total amount of your offer, only the figures before the decimal point. This is ',
          [RandomReaderInstructionTypes.ACCOUNT]: 'Enter ',
          [RandomReaderInstructionTypes.NUMBER]: 'Enter checksum',
          [RandomReaderInstructionTypes.COUNT]: 'Enter checksum',
        },
        rightSide: {
          [RandomReaderInstructionTypes.RANDOM]:
            '<br> and press <strong>OK</strong>.',
          [RandomReaderInstructionTypes.AMOUNT]:
            '. Then press <strong>OK</strong>',
          [RandomReaderInstructionTypes.ACCOUNT]:
            '. This is one of the account numbers you used. Then press <strong>OK</strong>.',
          [RandomReaderInstructionTypes.NUMBER]:
            '<br> and press <strong>OK</strong>.',
          [RandomReaderInstructionTypes.COUNT]:
            '<br> and press <strong>OK</strong>.',
        },
      },
      okAgain: 'Press <strong>OK</strong> again.',
      enterCode: {
        login:
          'Enter the access code that is shown on your Random Reader Comfort.',
        sign: 'Enter the sign code that is shown on your Random Reader Comfort.',
      },
    },
  },
};

export const rassRandomReaderTranslations = {
  [Language.NL]: nlTranslations,
  [Language.EN]: enTranslations,
  [Language.ES]: enTranslations,
  [Language.PT]: enTranslations,
};
